import { initScene } from './modules/scene.js'
import { initParticles } from './modules/particles.js'

const { scene, camera, renderer, loader } = initScene()
const { animateParticles, spawnDust } = initParticles(scene, loader)

window.addEventListener('mousemove', (e) => {
    spawnDust(
         (e.clientX / window.innerWidth)  * 2 - 1,
        -(e.clientY / window.innerHeight) * 2 + 1,
        camera
    )
})

window.addEventListener('touchmove', (e) => {
    if (!e.touches[0]) return
    spawnDust(
         (e.touches[0].clientX / window.innerWidth)  * 2 - 1,
        -(e.touches[0].clientY / window.innerHeight) * 2 + 1,
        camera
    )
}, { passive: true })

;(function animate() {
    requestAnimationFrame(animate)
    animateParticles(Date.now() * 0.001)
    renderer.render(scene, camera)
})()
